import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';

import auth from '@/js/auth';

export default {
	install : function(Vue) {
		Vue._ = _;
		Vue.prototype.$_ = _;

		Vue.axios = axios;
		Vue.prototype.$axios = axios;

		Vue.moment = moment;
		Vue.prototype.$moment = moment;

		Vue.auth = auth;
		Vue.prototype.$auth = auth;
	}
}